import styled from 'styled-components';

export const AttachmentContainer = styled.div`
  cursor: pointer;
`;

export const AttachmentsWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 10px;
`;
